import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
} from "@mui/material";
import { Cross } from "../../../shared/assets/icons";
import Styles from "../../../styles/vendorDashboard.module.css";
import capitalizeWords from "../../../helperFunctions/capitalizedWords";
import GlobalButton from "../../../shared/utils/GlobalButton";

const ItemMasterViewModal = ({ selectedItemData, setItemModalOpen }) => {
  const handleClose = () => setItemModalOpen(false);

  const formatDate = (date) => {
    if (!date) return "Not Available";
    return new Date(date).toLocaleDateString();
  };

  const basicInfo = [
    { label: "Category", value: selectedItemData?.category },
    { label: "Product Type", value: selectedItemData?.productType },
  ];

  const detailInfo = [
    {
      label: "Fabrication Detail",
      value: selectedItemData?.fabricationDetail,
    },
    {
      label: "Electrical Detail",
      value: selectedItemData?.electricalDetail,
    },
    {
      label: "Printing Detail",
      value: selectedItemData?.printingDetail,
    },
    { label: "Description", value: selectedItemData?.description },
  ];

  const systemInfo = [
    { label: "Created At", value: formatDate(selectedItemData?.createdAt) },
    { label: "Updated At", value: formatDate(selectedItemData?.updatedAt) },
  ];

  const renderSection = (title, data) => (
    <div className="bg-white rounded-lg shadow-md p-6 mb-4">
      <h3 className="text-xl font-bold text-gray-600 mb-4">{title}</h3>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {data.map((item, idx) => (
          <div key={idx}>
            <span className="font-bold text-gray-600">{item.label}</span>
            <p className="text-gray-600">
              {item.value && item.value !== "" ? item.value : "Not Available"}
            </p>
          </div>
        ))}
      </div>
    </div>
  );

  // for image preview modal
  const [isImagePreviewOpen, setIsImagePreviewOpen] = useState(false);

  const handleOpenPreview = () => {
    setIsImagePreviewOpen(true);
  };

  const handleCloseImagePreview = () => {
    setIsImagePreviewOpen(false);
  };

  return (
    <Dialog open={true} onClose={handleClose} fullWidth maxWidth="lg">
      <div className={`flex justify-between ${Styles.vendorModalColor}`}>
        <DialogTitle>Item Details</DialogTitle>
        <div onClick={handleClose} className="mx-5 my-4 cursor-pointer">
          <Cross />
        </div>
      </div>

      <DialogContent className={Styles.vendorModalColor}>
        <Box>
          {renderSection("Basic Information", basicInfo)}
          {renderSection("Item Details", detailInfo)}
          {renderSection("System Information", systemInfo)}
        </Box>
        <div className="bg-white rounded-lg shadow-md p-6 mb-4">
          <h3 className="text-xl font-bold text-gray-600 mb-4">
            Product Category Photo
          </h3>

          {selectedItemData?.productCategoryPhoto ? (
            <div className="flex justify-center items-center cursor-pointer">
              <img
                src={selectedItemData?.productCategoryPhoto}
                alt="Product Category"
                className="w-52 h-52 object-cover rounded-lg hover:scale-105 transition"
                onClick={handleOpenPreview}
              />
            </div>
          ) : (
            <p className="text-gray-500 text-center">No Image Available</p>
          )}
        </div>
      </DialogContent>

      <DialogActions>
        <div className="w-30">
          <GlobalButton variant="primary" size="medium" onClick={handleClose}>
            {`Close`}
          </GlobalButton>
        </div>
      </DialogActions>
      <Dialog
        open={isImagePreviewOpen}
        onClose={handleCloseImagePreview}
        maxWidth="md"
      >
        <Box className="p-4 flex justify-center items-center bg-gray-100">
          <img
            src={selectedItemData?.productCategoryPhoto}
            alt="Full Preview"
            className="max-w-[600px] max-h-[500px] object-contain rounded-lg"
          />
        </Box>
      </Dialog>
    </Dialog>
  );
};

export default ItemMasterViewModal;
